import { useTranslation } from 'next-i18next'
import { type ComponentProps } from 'react'
import { Select } from 'ui/src/components/Select/Select'
import { type CarMileageField as CarMileageFieldType } from '@/services/PriceCalculator/Field.types'

type Props = ComponentProps<typeof Select.Root> & {
  field: CarMileageFieldType
}

// NOTE: API values are in Scandinavian miles (1=10km)
const options = [
  { displayValue: '1 000', value: '1000' },
  { displayValue: '1 500', value: '1500' },
  { displayValue: '2 000', value: '2000' },
  { displayValue: '2 500', value: '2500' },
  { displayValue: '2 500+', value: '2501' },
]

export const CarMileageField = ({ field, ...selectProps }: Props) => {
  const { t } = useTranslation('purchase-form')

  const defaultValue = field.defaultValue ? String(field.defaultValue) : undefined

  return (
    <Select.Root name={field.name} defaultValue={defaultValue} required={field.required} {...selectProps}>
      <Select.Trigger fullWidth>
        <Select.Label>{t('FIELD_MILEAGE_LABEL')}</Select.Label>
        <Select.Value />
      </Select.Trigger>

      <Select.Content>
        <Select.Options>
          {options.map((option) => (
            <Select.Item key={option.value} value={option.value}>
              <Select.ItemText>{t('YEARLY_MILEAGE_VALUE', { value: option.displayValue })}</Select.ItemText>
            </Select.Item>
          ))}
        </Select.Options>
      </Select.Content>
    </Select.Root>
  )
}
